'use strict'

import {onFind} from "../libs/@elements/init-modules-in-scope";
import {removeAttribute, setAttribute, findIn, on} from "../libs/@elements/dom-utils";
import {createFormValidation} from "./form-validation";
import formDataEntries from "form-data-entries";
import fetch from "../libs/@elements/fetch";

let pendingRequest = null;

export function init() {

    onFind('.js-add-notify-availability__form', function (form) {

        let formButton = findIn('.js-add-notify-availability', form);
        let content = findIn('.modal-body', form);
        let loading = findIn('.js-notify-availability-form__loading', form);

        const pristine = createFormValidation(form);

        on('click', (evt) => {
            if (pendingRequest) {
                pendingRequest.abort();
                pendingRequest = null;
            }

            evt.preventDefault();

            if (!pristine.validate()){
                return;
            }

            let formData = formDataEntries(form);
            let params = new URLSearchParams(formData);
            let url = formButton.getAttribute('data-url');

            removeAttribute('hidden', loading);

            pendingRequest = fetch(url, {
                method: 'POST',
                body: params
            });

            pendingRequest
                .then((res) => {
                    return res.clone().json()
                })
                .then((res) => {
                    if (res.success) {
                        if (res.html) {
                            content.innerHTML = res.html;
                        }
                    }
                })
                .finally(() => {
                    setAttribute('hidden', true, loading);
                });
        }, formButton);
    });
}